import { z } from "zod";
import type { DropdownOption } from "../types/api.types.js";

const eligibleLifecycleUserSchema = z.object({
  id: z.string().uuid(),
  displayName: z.string().min(1),
  roleCode: z.string().nullable().optional(),
  organizationUnitName: z.string().nullable().optional(),
  isEligible: z.boolean(),
}).strict();

export function parseEligibleLifecycleUsers(input: unknown): readonly DropdownOption[] {
  return z.array(eligibleLifecycleUserSchema).parse(input)
    .filter((row) => row.isEligible)
    .map((row) => ({
      id: row.id,
      value: row.id,
      label: row.displayName,
      ...(row.roleCode ? { code: row.roleCode } : {}),
      metadata: {
        ...(row.roleCode ? { roleCode: row.roleCode } : {}),
        ...(row.organizationUnitName ? { organizationUnitName: row.organizationUnitName } : {}),
      },
    }));
}
